// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._22xe5f7CQG2FaS9qCguZlt{padding:3.2rem 0 10rem}@media only screen and (min-width:768px){._22xe5f7CQG2FaS9qCguZlt{padding:3.2rem 0 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cookiesSettings": "_22xe5f7CQG2FaS9qCguZlt"
};
module.exports = ___CSS_LOADER_EXPORT___;
